import { render } from "./AiAgentFab.vue?vue&type=template&id=3c3b3251&scoped=true"
import script from "./AiAgentFab.vue?vue&type=script&lang=js"
export * from "./AiAgentFab.vue?vue&type=script&lang=js"

import "./AiAgentFab.vue?vue&type=style&index=0&id=3c3b3251&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c3b3251"]])

export default __exports__